import './style.scss';
import LegalPageHeader from './LegalPageHeader';

function TermsAndConditions() {
    return (
        <div className="vivo-legal-wrap">
            <LegalPageHeader />
            <section className="section" style={{ padding: '2rem 0 0' }}>
                <iframe
                    src="https://app.termly.io/policy-viewer/policy.html?policyUUID=0f714323-588c-43fd-8a8d-715e5add3191"
                    title="Terms and Conditions"
                    style={{ width: '100%', minHeight: '85vh', border: 'none', display: 'block' }}
                />
            </section>
        </div>
    );
}

export default TermsAndConditions;
